import { Paper } from 'shared/ui/paper'

import s from './styles.module.scss'

export const ApplicationCardSkeleton = () => {
  return (
    <Paper
      padding={[12]}
      radius="16px"
      className={s.card}
    >
      <div
        className={s.content}
        aria-hidden="true"
      >
        <span className={s.dateBadge} />

        <div className={s.info}>
          <span className={s.titleLine} />
          <span className={s.detailsLine} />
          <span className={s.addressLine} />
        </div>

        <div className={s.divider} />

        <div className={s.actions}>
          <span className={s.actionButton} />
          <span className={s.actionButton} />
        </div>
      </div>
    </Paper>
  )
}
